
import React from 'react';
import { Check } from 'lucide-react';
import { FormStepIndicatorProps } from './types';
import { cn } from '@/lib/utils';

const FormStepIndicator: React.FC<FormStepIndicatorProps> = ({ 
  currentStep, 
  totalSteps,
  stepTitles 
}) => {
  // Get the appropriate utility color class based on the page URL
  const getUtilityAccentColor = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('water')) return 'bg-sky-500 text-white';
    if (path.includes('gas')) return 'bg-amber-500 text-white';
    return 'bg-emerald-500 text-white';
  };

  const accentColorClass = getUtilityAccentColor();

  return (
    <div className="relative mb-8">
      <div className="flex items-center justify-between">
        {stepTitles.map((step, index) => (
          <React.Fragment key={index}>
            <div className={cn(
              "flex items-center", 
              currentStep >= index + 1 ? "text-primary" : "text-muted-foreground"
            )}>
              <div className={cn(
                "w-8 h-8 rounded-full flex items-center justify-center mr-2 transition-colors duration-200",
                currentStep > index + 1 ? accentColorClass : 
                currentStep === index + 1 ? "border-2 border-current" : 
                "bg-muted text-muted-foreground"
              )}>
                {currentStep > index + 1 ? <Check className="h-4 w-4" /> : `${index + 1}`}
              </div>
              <div>
                <span className="font-medium">{step.title}</span>
                {step.optional && (
                  <span className="text-xs ml-2 text-muted-foreground">(Optional)</span>
                )}
              </div>
            </div>
            
            {index < totalSteps - 1 && (
              <div className={cn(
                "flex-1 mx-4 h-0.5", 
                index < currentStep - 1 ? "bg-primary" : "bg-border"
              )} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FormStepIndicator;
